import { call, select } from 'redux-saga/effects';
import { selectRtcStatsServer } from 'features/system-stats/systemStatsSlice';
import { RtcStatsServer } from 'features/room/types';
import { getStatsTrace, RTCSTATS_WS_URL } from 'utils/webrtc/stats/install-rtcstats';

export const resolveRtcStatsWsUrl = (
  server: RtcStatsServer | null,
  fallbackUrl: string | undefined
): string | undefined => (server ? `${server.url}?rtcstats-token=${server.token}` : fallbackUrl);

export function* connectStatsTraceOnRoomJoined() {
  const trace = getStatsTrace();
  if (!trace) {
    return;
  }

  const server: RtcStatsServer | null = yield select(selectRtcStatsServer);
  const wsUrl = resolveRtcStatsWsUrl(server, RTCSTATS_WS_URL);
  if (!wsUrl) {
    return; // no backend server and no dev sink → do nothing
  }

  yield call([trace, trace.connect], wsUrl);
}

/** Close the rtcstats socket at session end. Not called on reconnect — the socket must survive to keep one continuous dump. */
export function* closeStatsTrace() {
  const trace = getStatsTrace();
  if (!trace) {
    return;
  }
  yield call([trace, trace.close]);
}
